import { render, staticRenderFns } from "./TableThermalVision.vue?vue&type=template&id=0dfbd113"
import script from "./TableThermalVision.vue?vue&type=script&lang=js"
export * from "./TableThermalVision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports